import { Link } from 'react-router-dom';

const footerLinks = {
  攻略内容: [
    { label: '剧情攻略', href: '/category?tab=剧情攻略' },
    { label: '新手入门指南', href: '/article/beginner-guide' },
    { label: '全结局解析', href: '/article/story-guide-complete' },
  ],
  角色解读: [
    { label: '角色解析', href: '/category?tab=角色解析' },
    { label: '春日野穹解析', href: '/article/kasugano-sora-analysis' },
    { label: '天女目瑛解析', href: '/article/amatsume-akira-analysis' },
  ],
  深度评论: [
    { label: '主题评测', href: '/category?tab=主题评测' },
    { label: '感动结局', href: '/category?tab=感动结局' },
    { label: '玩家评价', href: '/category?tab=玩家评价' },
  ],
  关于本站: [
    { label: '关于我们', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-8">
        {/* Top */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-heart-pulse-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">悠之空</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              探索缘之空的深刻世界，感受那跨越界限的纯粹情感冲击。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{group}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 悠之空. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <p className="text-xs text-foreground-600">
            关键词：缘之空剧情攻略 · 缘之空角色解析 · 缘之空视觉小说
          </p>
        </div>
      </div>
    </footer>
  );
}